<!-- 响应式M版头部 -->
<template>
<div class="media-header">
    <div class="header-main">
        <YorkbbsImage
          width="96px"
          height="30px"
          :src="require('@/assets/images/common/logo_image.png')"
          target="_blank"
          :link="`/` | hostBuild('www')"
        ></YorkbbsImage>
        <div class="flex-cont"></div>
        <a class="to-login" :href="loginUrl" v-if="!isLogin">登录</a>
        <YorkbbsImage
            v-else
          width="30px"
          height="30px"
          :src="avatar"
          target="_blank"
          borderRadius="50%"
          :link="homeURL"
        ></YorkbbsImage>
        <div class="menu" :class="{active:showMenu}" @click="showMenu = !showMenu">
            <span></span><span class="middle"></span><span></span>
        </div>
    </div>
    <div class="media-menu" :class="{active:showMenu}">
        <ul class="nav__list">
          <li class="header-nav__item">
            <a :href="`/` | hostBuild('www')" title="首页" target="_blank">首页</a>
          </li>
          <li class="header-nav__item">
            <a :href="`/` | hostBuild('news')" title="新闻" target="_blank">新闻</a>
          </li>
          <li class="header-nav__item">
            <a :href="`/` | hostBuild('house')" title="房产" target="_blank">房产</a>
          </li>
          <li class="header-nav__item">
            <a :href="`/` | hostBuild('car')" title="汽车" target="_blank">汽车</a>
          </li>
          <li class="header-nav__item">
            <a :href="`/` | hostBuild('info')" title="黄页" target="_blank">黄页</a>
          </li>
          <li class="header-nav__item">
            <a :href="`/list/restaurants` | hostBuild('info')" title="美食" target="_blank">美食 </a>
          </li>
          <li class="header-nav__item">
            <a :href="`/` | hostBuild('job')" title="招聘" target="_blank">招聘</a>
          </li>
          <li class="header-nav__item">
            <a :href="`/` | hostBuild('forsale')" title="二手" target="_blank">二手</a>
          </li>
          <li class="header-nav__item">
            <a :href="`/` | hostBuild('forum')" title="论坛" target="_blank">论坛</a>
          </li>
        </ul>
    </div>
</div>
</template>
<script>
import { hostBuild } from '@/utils/utils';
export default {
    name:'MediaHeader',
    data(){
        return {
            showMenu:false,
        }
    },
    computed: {
        // 是否登录
        isLogin() {
            return this.$store.getters.isLogin;
        },
        // 用户头像
        avatar() {
            return this.$store.getters.user.avatar;
        },
        // 用户ID
        userId() {
            return this.$store.getters.user.id;
        },
        // 用户名
        username() {
            return this.$store.getters.user.username;
        },
        // 用户主页
        homeURL() {
            return hostBuild(`/home/${this.userId}`, 'home');
        },
        // 通知总数量
        noticeNum() {
            return (
                this.atUserCount +
                this.commentNoticeCount +
                this.systemNoticeCount +
                this.thumbUpCount +
                this.attentionToMeCount
            );
        },
        loginUrl(){
            return hostBuild(`/login?redirect=${window.location.href}`,'account');
        }
    },
}
</script>
<style lang="less" scoped>
.media-header{
    position: fixed; z-index: 10; left: 0; top: 0; right: 0; background: #fafafa;
    .header-main{
        display: flex; align-items: center;padding:0 10px; height: 45px;
        .flex-cont{flex:1;}
        .to-login{
            line-height: 26px; font-size: 12px; padding: 0 10px; border:1px solid #eee; border-radius: 4px; background: #fff; color: #333;
        }
        .menu{
            width: 18px; height: 18px; position: relative; cursor: pointer; margin-left: 20px;
            span{
                width:18px; height: 2px; background: #000; border-radius: 2px; position: absolute;
                &.middle{left: 0; top: 50%; transform: translateY(-50%);}
                &:first-child{left: 0; top: 0;}
                &:last-child{left: 0; bottom: 0;}
            }
            &.active{
         
                span{

                    &.middle{display: none;}
                    &:first-child{top: 50%; transform-origin: center; transform: translateY(-50%) rotateZ(45deg);}
                    &:last-child{bottom:50%;transform-origin: center; transform: translateY(50%) rotateZ(-45deg);}
                }
            }
        }
    }
    .media-menu{
        position: fixed; z-index:-1; left: 0; top: 45px; right: 0; display: none;
        .nav__list{
            display: flex; flex-wrap: wrap; background: #fafafa; padding: 15px 0 0 20px;
            li{
                width:20%; margin-bottom: 20px;
                a{font-size: 16px; line-height: 24px; color: #111;}
            }
        }
        &.active{
            display: block; opacity: 0;
            animation-name: menuSlideDown;
            animation-duration: 150ms;
            animation-timing-function: linear;
            animation-fill-mode: forwards;
        }
    }
}
@keyframes menuSlideDown {
    0%{
        opacity: 0; transform: translateY(-50px);
    }
    100%{
        opacity: 1; transform: translateY(0);
    }
}
</style>